<template>
  <div>
    <el-row class="banner-box">
      <el-carousel height="530" :autoplay="true" arrow="never" :initial-index="bannerIndex" @change="changeBanner">
        <el-carousel-item v-for="(item,index) in bannerList" :key="index">
          <el-col class="banner" :style="{'background-image' : 'url('+ item.src +')'}">
            <el-button :class="'banner-btn'+index" @click="clickMoreHander(item.path)">了解详情</el-button>
          </el-col>
        </el-carousel-item>
      </el-carousel>
      <el-row class="zytb-right">
        <el-row class="zytb-box zytb-box-home">
            <el-row>
              <el-col :span="3">
              <img src="../../assets/images/chatu.png" alt="志愿填报" class="zytb-img1">
              </el-col>
              <el-col :span="21">
                <h2>模拟高考志愿填报</h2>
                <h4>一键查询适合你的学校和专业</h4>
              </el-col>
            </el-row>
          <el-form v-if="optionsProvince" :inline="true" :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="zytb-form">
            <el-form-item label="高考省份：" prop="province">
              <el-input disabled v-if="token" type="text" v-model="optionsProvince[provinceCode]" autocomplete="off" placeholder="请选择高考省份" />
              <el-input type="text" v-model="optionsProvince[provinceCode]" autocomplete="off" placeholder="请选择高考省份" v-click-with-auth-login :readonly="readonly" v-else>
                <!-- <template slot="append">
                  <i class="el-select__caret el-input__icon el-icon-arrow-down"></i>
                </template> -->
              </el-input>
            </el-form-item>
            <el-form-item label="科目组合：" prop="local_type_id" class="select-subject">
               <el-input disabled v-if="token" type="text" v-model="ruleForm.subject_name" autocomplete="off" placeholder="请选择科目" />
              <el-input type="text" v-model="ruleForm.subject_name" autocomplete="off" placeholder="请选择科目" v-click-with-auth-login :readonly="readonly" v-else />
            <!--   <el-radio-group v-model="ruleForm.local_type_id" disabled>
                <el-radio v-for="(item,key) in optionsSub" :label="String(key)" v-click-with-auth-login>{{ item }}</el-radio>
              </el-radio-group> -->
            </el-form-item>
            <el-form-item label="选择批次：" prop="local_batch_type">
              <el-select v-model="ruleForm.local_batch_type" placeholder="请选择高考批次" v-if="token">
                  <el-option
                  v-for="item in options"
                  :key="item.local_batch_id"
                  :label="item.name"
                  :value="item.local_batch_id">
                  </el-option>
              </el-select>
              <el-input type="text" v-else-if="options.length > 0" v-model="options[0].name" autocomplete="off" placeholder="请选择高考批次" v-click-with-auth-login :readonly="readonly">
                <template slot="append">
                  <i class="el-select__caret el-input__icon el-icon-arrow-down"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="高考总分：" prop="score">
              <el-input type="text" v-model.number="ruleForm.score" autocomplete="off" placeholder="请输入高考总分" v-click-with-auth-login :readonly="readonly">
                <template slot="append">分</template>
              </el-input>
            </el-form-item>
            <el-row class="zytb-btn">
              <el-button @click.native="submitFormHandler" v-click-with-auth-login>查询适合你的学校和专业</el-button>
            </el-row>
          </el-form>
        </el-row>
      </el-row>
    </el-row>
    <el-row class="white-color-bg">
      <m-shelf :title="titleList[3].title" class="spe-box" :isShow="false" :isFix="true">
        <el-row slot="content">
          <el-row type="flex" justify="space-between">
            <el-col :span="3" @click.native="linkToList(index)" @mouseenter.native="addSpeClass(index)" @mouseleave.native="removeSpeClass(index)" :class="activeNavIndex === index?'active-spc-class':''" v-for="(item,index) in navList" :key="index">
              <img :src="activeNavIndex === index?navListHover[index].src:item.src" :alt="item.name">
              <h5>{{item.name}}</h5>
            </el-col>
          </el-row>
          <!-- <el-row class="tools-box">
            <el-row>
              <el-col :span="20" class="tools-title"><img src="../../assets/images/tools.png" alt="高考工具箱" class="tools-img"> 高考工具箱</el-col>
              <el-col :span="4" class="infor-right">
                  <a @click="goToLinkTools">查看全部<img src="../../assets/images/jt.png" alt="查看全部"></a>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8" class="tools-item" v-for="(item, index) in toolsList" :key="index">
                <el-row class="tools-item-content" type="flex" justify="left" @click.native="toolsHandler(index)">
                  <img :src="item.src" class="tools-batch">
                  <div>
                    <el-row type="flex" justify="left">
                      <h6>{{item.name}}</h6>
                      <img src="../../assets/images/jt.png" class="tools-arrow">
                    </el-row>
                    <div class="tools-desc">{{item.desc}}</div>
                  </div>
                </el-row>
              </el-col>
            </el-row>
          </el-row> -->
        </el-row>
      </m-shelf>
    </el-row>
    <m-shelf :title="titleList[0].title" class="evaluation-box" :isShow="false" :isFix="true">
      <!-- <el-row slot="content" type="flex" justify="space-between"> -->
      <el-row slot="content" type="flex" justify="space-between">
        <el-card class="evaluation-card" @click.native="linkEvaluationDetailHandler(3)">
          <div class="evaluation-img1">
            <img src="../../assets/images/zy2.png" alt="智能测评">
          </div>
          <div>
            <h3>学业目标测评(Goal)</h3>
            <h5>帮助学生明确升学目标，激发学习动力</h5>
            <h6>
              <img src="../../assets/images/people-orange.png" alt="完成人数">
              {{experienceList[2]}}人已完成
            </h6>
          </div>
        </el-card>
        <el-card class="evaluation-card" @click.native="linkEvaluationDetailHandler(0)">
          <div class="evaluation-img1">
            <img src="../../assets/images/zy.png" alt="智能测评">
          </div>
          <div>
            <h3>霍兰德职业兴趣测试</h3>
            <h5>5大维度 10分钟推荐适合你的专业</h5>
            <h6>
              <img src="../../assets/images/people-orange.png" alt="完成人数">
              {{experienceList[0]}}人已完成
            </h6>
          </div>
        </el-card>
        <el-card class="evaluation-card evaluation-card-box2" @click.native="linkEvaluationDetailHandler(1)">
          <div class="evaluation-img1">
            <img src="../../assets/images/zy1.png" alt="智能测评">
          </div>
          <div>
            <h3>MBTI职业性格测试</h3>
            <h5>你的性格，适合什么样的职业？</h5>
            <h6>
              <img src="../../assets/images/people-orange.png" alt="完成人数">
              {{experienceList[1]}}人已完成
            </h6>
          </div>
        </el-card>
          <!-- <el-card class="evaluation-card evaluation-card-box2" @click.native="linkEvaluationDetailHandler(1)">
            <div class="evaluation-img1">
              <img src="../../assets/images/zy1.png" alt="智能测评">
            </div>
            <div>
              <h3>MBTI职业性格测试</h3>
              <h5>你的性格，适合什么样的职业？</h5>
              <h6>
                <img src="../../assets/images/people-orange.png" alt="完成人数">
                {{experienceList[1]}}人已完成
              </h6>
            </div>
          </el-card>
          <el-card class="evaluation-card evaluation-card-box2" @click.native="linkEvaluationDetailHandler(1)">
            <div class="evaluation-img1">
              <img src="../../assets/images/zy1.png" alt="智能测评">
            </div>
            <div>
              <h3>MBTI职业性格测试</h3>
              <h5>你的性格，适合什么样的职业？</h5>
              <h6>
                <img src="../../assets/images/people-orange.png" alt="完成人数">
                {{experienceList[1]}}人已完成
              </h6>
            </div>
          </el-card> -->
      </el-row>
    </m-shelf>
    <el-row class="white-color-bg" style="padding-bottom: 48px">
      <el-row class="school-box">
        <el-col :span="17" class="rank-box1">
          <m-shelf :title="titleList[1].title" :isShow="true" :isFix="false">
            <el-tabs type="border-card" slot="content" @tab-click="schoolRankHandler">
              <el-tab-pane :label="card.name" v-for="(card,index) in cardList" :key="index">
                <el-row v-if="recommendStatus == '1'">
                  <el-col :span="8" v-for="index1 in 15" :key="index1">
                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="100" width="255">
                      <rect x="0" y="0" width="240" height="90" />
                    </ContentLoader>
                  </el-col>
                </el-row>
                <div class="no-data-box" v-else-if="recommendStatus == '2'">
                  <img src="../../assets/images/null.png" alt="没有数据">
                  <p>暂无数据</p>
                </div>
                <el-row v-else-if="recommendStatus == '3'" type="flex" justify="space-between" class="school-rank-list">
                  <el-col :span="8" v-for="(school,index1) in recommendList" :key="index1" @click.native="schoolDetailHandler(school.scl_id)">
                      <el-row type="flex" justify="space-between" align="middle" class="school-rank-item">
                        <el-col :span="6">
                          <el-image :src="'https://gaokao.zmpajx.com/pic/' + school.scl_id + '.jpg'" alt="大学logo">
                              <div slot="error" class="image-slot">
                                  <img src="../../assets/images/scl_default.png" alt="大学logo" class="rank-img">
                              </div>
                          </el-image>
                        </el-col>
                        <el-col :span="18">
                          <h6 :title="school.scl_name">{{school.scl_name}}</h6>
                        </el-col>
                      </el-row>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </m-shelf>
        </el-col>
        <el-col :span="7">
          <m-shelf :title="titleList[4].title" :isShow="true" :isFix="false">
            <el-row slot="content">
              <el-row class="recom-btn">
                <span v-for="(item,index) in btnList" :key="index" :class="index==activeBtnIndex?'activeBtn':''" @click="changeRecommend(index)">{{item.value}}</span>
              </el-row>
              <el-row class="recommend-box">
                <el-row v-if="rankStatus == '1'">
                  <el-col v-for="index1 in 10" :key="index1">
                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="40" width="300">
                      <rect x="0" y="15" width="20" height="20" />
                      <rect x="30" y="15" width="200" height="20" />
                    </ContentLoader>
                  </el-col>
                </el-row>
                <div class="no-data-box" v-else-if="rankStatus == '2'">
                  <img src="../../assets/images/null.png" alt="没有数据">
                  <p>暂无数据</p>
                </div>
                <el-col v-else-if="rankStatus == '3'" v-for="(school,index1) in schoolList" :key="index1" @click.native="schoolDetailHandler(school.scl_id)">
                  <el-row>
                    <el-col :span="2">
                      <div class="rank-number rank-number-top1" v-if="index1 == 0">
                        <img src="../../assets/images/rank-top1.png"/>
                      </div>
                      <div class="rank-number rank-number-top2" v-else-if="index1 == 1">
                        <img src="../../assets/images/rank-top2.png"/>
                      </div>
                      <div class="rank-number rank-number-top3" v-else-if="index1 == 2">
                        <img src="../../assets/images/rank-top3.png"/>
                      </div>
                      <div class="rank-number" v-else>{{index1+1}}</div>
                    </el-col>
                    <el-col :span="17">
                      <h6 :title="school.scl_name" :class="index1 < 3 ? 'h6-top2': ''">{{school.scl_name}}</h6>
                    </el-col>
                    <!-- <el-col :span="5">
                      <img src="../../assets/images/fire1.png" v-if="index1<3" />
                      <img src="../../assets/images/fire2.png" v-else />
                      <span :class="index1 < 3 ? 'span-top': ''">100</span>
                    </el-col> -->
                  </el-row>
                </el-col>
              </el-row>
            </el-row>
          </m-shelf>
        </el-col>
      </el-row>
    </el-row>
    <m-shelf :title="titleList[5].title" :isShow="true" :isFix="true">
      <el-row slot="content" class="class-box">
        <el-row v-if="videoStatus == '1'">
          <el-col v-for="index1 in 8" :key="index1" :span="6">
            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="210" width="300">
              <rect x="0" y="20" width="280" height="150" />
            </ContentLoader>
          </el-col>
        </el-row>
        <div class="no-data-box" v-else-if="videoStatus == '2'">
            <img src="../../assets/images/null.png" alt="没有数据">
            <p>暂无数据</p>
        </div>
        <el-row v-else-if="videoStatus == '3'" class="class-box-list" type="flex" justify="space-between">
          <el-col :span="6" v-for="(item,index) in videoList" :key="index" @click.native="linkToDetail(item.id)">
            <div class="video-box">
              <div class="video-bg" :style="{backgroundImage:'url(' + item.video_pic + ')'}">
                <img src="../../assets/images/play.png" alt="播放视频">
              </div>
              <el-row style="margin-top: -41px;padding-left:12px;background: linear-gradient(180deg,rgba(0,0,0,0.00), rgba(0,0,0,0.50));border-radius: 10px;">
                <el-col :span="3">
                    <div class="video-free" v-if="item.video_type == 0">免费</div>
                    <div class="video-free video-free-vip" v-else>会员</div>
                </el-col>
                <el-col :span="21">
                    <p>{{item.video_title}}</p>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </m-shelf>
    <el-row class="school-search-box">
      <h2>全国大学信息查询</h2>
      <h5>在线查询大学信息，招生详情，开设专业一键掌握</h5>
      <el-button @click="linkToSchool">查询大学</el-button>
    </el-row>
    <el-row class="white-color-bg">
      <el-row class="news-infor-box">
        <el-col :span="17" class="lecture-box">
          <m-shelf :title="titleList[6].title" :isShow="true" :isFix="false">
          <el-row slot="content" class="lecture-list">
            <div v-if="lectureStatus == '1'">
              <el-col v-for="index1 in 6" :key="index1" :span="8">
                <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="210" width="300">
                    <rect x="0" y="20" width="300" height="150" />
                    <rect x="0" y="185" width="200" height="25" />
                  </ContentLoader>
                </el-col>
            </div>
            <div class="no-data-box" v-else-if="lectureStatus == '2'">
              <img src="../../assets/images/null.png" alt="没有数据">
              <p>暂无数据</p>
            </div>
            <el-row v-else-if="lectureStatus == '3'">
              <el-col :span="8" v-for="(item,index) in lectureList" @click.native="goDetailHandler(item.id)" :key="index">
                <div class="lecture-img" :style="{backgroundImage:'url(' + item.banner_url + ')'}">
                </div>
                <p>{{item.news_title}}</p>
                <div class="lecture-time">{{item.create_time|formatDate}}</div>
              </el-col>
            </el-row>
          </el-row>
          </m-shelf>
        </el-col>
        <el-col :span="7" class="news-box1">
          <m-shelf :title="titleList[2].title" :isShow="true" :isFix="false">
            <el-row slot="content">
                  <div v-if="newsStatus == '1'">
                    <ContentLoader v-for="item in 9" :key="item" primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="70" width="500" viewBox="0 0 1000 60">
                      <rect x="0" y="10" width="400" height="30" />
                    </ContentLoader>
                  </div>
                  <div class="no-data-box" v-else-if="newsStatus == '2'">
                    <img src="../../assets/images/null.png" alt="没有数据">
                    <p>暂无数据</p>
                  </div>
                  <el-row v-else-if="newsStatus == '3'">
                    <div class="news-title" v-for="(item,index) in newsList" @click="goDetailHandler(item.id)" :key="index">{{item.news_title}}</div>
                  </el-row>
            </el-row>
          </m-shelf>
        </el-col>
      </el-row>
      <el-row class="vip-img">
        <el-row class="vip-img-content">
          <el-col :span="1">
            <img src="../../assets/images/vip_icon.png" alt="开通VIP" class="vip-img-icon">
          </el-col>
          <el-col :span="10">
            <h3>开通{{ website.name ? website.name : '荔枝生涯' }}会员，助力孩子走上成功路！</h3>
          </el-col>
          <el-col :span="2">
            <button v-if="isVipStr == 'false'" @click="showVipHandler">激活会员</button>
          </el-col>
          <el-col :span="11">
            <img src="../../assets/images/banner_vip-person.png" class="vip-img-person">
          </el-col>
        </el-row>
      </el-row>
    </el-row>
    <!-- <div v-if="isLogin">
      <Login></Login>
    </div> -->
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import MShelf from "@/components/Shelf.vue"
import { newsList } from '@/api/news'
import { schoolNews } from '@/api/home'
import { schoolRank, recommendSchool, getRecomendVideo, getEvaluationTimes } from '@/api/home'
import { getToken } from '@/utils/auth'
import { teamInfoEdit, teamInfo } from '@/api/user'
import { getVideoUrl } from '@/api/video'
import { mapState } from 'vuex'
import { ContentLoader } from 'vue-content-loader'
//import { Message } from 'element-ui'

export default {
  components: {
    MShelf,
    ContentLoader
  },
  data() {
    const validateGrade = (rule, value, callback) => {
      if(!this.$store.state.user.token) {
        return
      }
        if (value.length === 0) {
          callback(new Error("请输入高考总分"));
        } else {
          if (!(/(^[1-9]\d*$)/.test(value)) || value > 750) {
            callback(new Error("请输入正确的高考总分"));
          } else {
            callback();
          }
        }
	};
	const validateRank = (rule, value, callback) => {
		if (value.length === 0) {
		  callback();
		} else {
		  if (!(/(^[1-9]\d*$)/.test(value))) {
			callback(new Error("请输入正确排名"));
		  } else {
			callback();
		  }
		}
	};
    return {
      titleList: [
        {
          title: '职业智能评测'
        },
        {
          title: '推荐大学'
        },
        {
          title: '高考热门资讯'
        },
        {
          title: '特色功能'
        },
        {
          title: '大学排行'
        },
        {
          title: '高考课堂'
        },
        {
          title: '公益讲座'
        }
      ],
      cardList: [
        {
          name: '',
        }
      ],
      schoolList: [],
      newsList: [],
      ruleForm: {
        province: '',
        local_type_id: '1',
        subject_name: '',
        local_batch_type: '7',
        score: '',
        section_line: '',
        type: '1'
      },
      
      optionsProvince: {},
      options: [],
      rules: {
        score: [
          { required: true, trigger: 'blur', validator: validateGrade }
        ],
        section_line: [
          { type: 'number',trigger: 'blur', validator:validateRank }
        ],
        local_type_id: [
          { required: true }
        ],
        local_batch_type: [
          { required: true }
        ]
      },
      rankType: 1,
      zyInfor: {
        type: '1'
      },
      activeBtnIndex: 0,
      activeCateIndex: 0,
      btnList: [
        {
          type: '6000',
          value: '本科'
        },
        // {
        //   type: '6001',
        //   value: '专科'
        // }
      ],
      videoBg: require("../../assets/images/news1.png"),
      newsCardList: [
        {'cate_name': '1'}
      ],
      scl_nature_type_recom: '6000',
      recommendList: [],
      videoList: [],
      subject_obj: JSON.parse(sessionStorage.getItem('subjectObj')),
      noNewsData: false,
      selectId: '',
      recommendStatus: '1',
      rankStatus: '1',
      videoStatus: '1',
      newsStatus: '1',
      lectureStatus: '1',
      activeNavIndex: null,
      navList: [
        {src: require('../../assets/images/school-logo.png'),name: '查学校'},
        {src: require('../../assets/images/major-logo.png'),name:'查专业'},
        {src: require('../../assets/images/zytb-logo.png'),name:'志愿填报'},
        {src: require('../../assets/images/rank-logo.png'),name:'院校排行榜'},
        {src: require('../../assets/images/znpc-logo.png'),name:'智能评测'},
        {src: require('../../assets/images/news-logo.png'),name:'高考资讯'},
        {src: require('../../assets/images/tools-batch.png'),name:'批次线查询'},
        {src: require('../../assets/images/tools-rank.png'),name:'位次查询'}
      ],
      navListHover: [
        {src: require('../../assets/images/school-logo-hover.png')},
        {src: require('../../assets/images/major-logo-hover.png')},
        {src: require('../../assets/images/zytb-logo-hover.png')},
        {src: require('../../assets/images/rank-logo-hover.png')},
        {src: require('../../assets/images/znpc-logo-hover.png')},
        {src: require('../../assets/images/news-logo-hover.png')},
        {src: require('../../assets/images/tools-batch-hover.png')},
        {src: require('../../assets/images/tools-rank-hover.png')}
      ],
      experienceList: [],
      bannerList: [
        {src: require('../../assets/images/banner1.png'), path: '/basicPlan'},
        {src: require('../../assets/images/banner2.jpg'), path: '/sergeant'},
        {src: require('../../assets/images/banner3.jpg'), path: '/overseas'},
        {src: require('../../assets/images/banner4.png'), path: '/submitStudents'}
      ],
      bannerIndex: 0,
      readonly: true,
      toolsList: [
        {src: require('../../assets/images/tools-batch.png'),name: '批次线查询',desc: '查询近五年录取批次线',path: ''},
        {src: require('../../assets/images/tools-rank.png'),name: '位次查询',desc: '查询当年对应位次',path: ''},
        {src: require('../../assets/images/tools-score.png'),name: '艺术分数换算',desc: '查询不同院校文化课成绩与艺术成绩比例',path: ''}
      ],
      lectureList: []
    }
  },
  filters: {
    formatDate: function(time) {
      time = time * 1000
      let date = new Date(time);
      let YY = date.getFullYear();
      let MM = date.getMonth() + 1;
      let DD = date.getDate();
      return YY + '.' + MM + '.' + DD;
    }
  },
  computed: {
    ...mapState({
        isLogin: state => state.user.isLogin,
        token: state => state.user.token,
        isVipStr: state => state.user.isVipStr,
        provinceCode: state => state.user.provinceCode,
        isProvince: state => state.user.isProvince,
        localTypeId: state => state.user.localTypeId,
        subject_name: state => state.user.subject_name,
        gk_year: state => state.user.gk_year,
        isShowProvince: state => state.user.isShowProvince,
        website: state => state.user.website
    }),
  },
  watch: {
    token (newVal) {
      if(newVal != '') {
        this.readonly = false;
        this.showAreaHandler();
        if(this.ruleForm.score) {
          this.teamInfoAddHandler();
        } else {
          this.teamInfoHandler();
        }
      }
    },
    provinceCode (newVal) {
      this.ruleForm.province = newVal;
      this.recommendSchool();
    },
    localTypeId (newVal) {
      this.ruleForm.local_type_id = String(newVal);
    },
    subject_name (newVal, oldVal) {
      this.ruleForm.subject_name = newVal;
    },
    gk_year(newVal) {
      this.ruleForm.year = newVal;
    },
    isProvince(newVal) {
      this.showAreaHandler()
    },
    isShowProvince(newVal) {
      this.showAreaHandler()
    }
  },
  mounted() {
    if(this.$store.state.user.token) {
      this.readonly = false;
      this.teamInfoHandler()
    } else {
      this.readonly = true;
    }
    if(this.isShowProvince) {
      this.showAreaHandler()
    }
    this.$store.commit('user/ADDCOUNT', 0);
    this.activeNavIndex = '';
    this.ruleForm.local_type_id = this.localTypeId || '1';
    this.ruleForm.province = this.provinceCode || '41';
    this.ruleForm.subject_name = this.subject_name || '物理,化学,生物';
    this.schoolRankHandler({index: '0'});
    this.recommendSchool();
    this.getRecomendVideo();
    this.newsCardListHandler();
    this.getEvaluationTimes();
  },
  methods: {
    teamInfoHandler(flag) {
      teamInfo().then(res => {
        if(res.data) {
          this.ruleForm.year = res.data.year
          this.ruleForm.area = res.data.area
          this.ruleForm.local_type_id = res.data.local_type_id
          this.ruleForm.local_batch_type = res.data.local_batch_type
          this.ruleForm.subject_name = res.data.subject_name ? res.data.subject_name : subject_obj[res.data.local_type_id]
          if(res.data.subject_name) {
            this.$store.commit('user/CHANGESUBJECT', res.data.subject_name)
          }
          if(res.data.local_type_id) {
            this.$store.commit('user/CHANGELOCALTYPEID', res.data.local_type_id)
          }
        }
      })
    },
    showAreaHandler() {
      this.options = []
      this.optionsProvince = {}
      const areaInfo = JSON.parse(sessionStorage.getItem('proInfo'))
      areaInfo.map(item => {
        this.optionsProvince[item.area] = item.name;
      })
      const area_tmp = areaInfo.filter(val => { return val.area === this.$store.state.user.provinceCode});
      this.options = area_tmp[0].local_batch_id
      this.ruleForm.local_batch_type = this.options[0].local_batch_id
      this.$forceUpdate()
    },
    schoolRankHandler(e) {
      this.rankStatus = '1';
      this.schoolList = [];
      let rank_type =  parseInt(e.index) + 1;
      schoolRank(rank_type).then(res => {
        if(res.data.length == 0) {
          this.rankStatus = '2';
        } else {
          this.rankStatus = '3';
          this.schoolList = res.data;
        }
      })
    },
    linkEvaluationHandler() {
      this.$router.push({
          path: '/evaluation'
      })
    },
    schoolDetailHandler(scl_id) {
      this.$router.push({
        path:'/schoolDetail',
          query: {
            scl_id: scl_id
          }
      })
    },
    teamInfoAddHandler() {
      let {score, local_type_id, local_batch_type, year, subject_name } = this.ruleForm;
      if(!this.ruleForm.year) {
        year = new Date().getFullYear()
        if(new Date().getMonth() > 7) {
          year = (new Date().getFullYear()) + 1
        }
      }
      teamInfoEdit(score, local_type_id, local_batch_type, year, subject_name).then(res => {
        if(res.status != 400) {
          this.querySchoolHandler('3');
        }
      })
    },
    submitFormHandler() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$store.commit('user/EDITGKINFOR',this.ruleForm);
          if(getToken().length == 0) {
            this.$store.commit('user/LOGINSTATUS', true);
          } else {
            this.teamInfoAddHandler();
          }
        }
      })
    },
    goDetailHandler(id) {
      this.$router.push({
				path:'/newsDetail',
          query: {
              id: id
          }
			})
    },
    querySchoolHandler(type) {
      this.$router.push({
        path:'/zhiyuan',
        // name: 'zhiyuan',
        // params: {
        //   type: type
        // }
      })
    },
    linkToList(index) {
      switch(index){
        case 0:
          this.linkToSchool();
          break;
        case 1:
          this.linkToMajor();
          break;
        case 2:
          this.querySchoolHandler('3');
        break;
        case 3:
          this.linkMoreHandler();
          break;
        case 4:
          this.linkEvaluationDetailHandler(0);
          break;
        case 5:
          this.linkNewHandler();
          break;
        case 6:
          this.goToLinkToolsRank();
          break;
        case 7:
          this.goToLinkToolsRank();
          break;
        default:
          break;
      }
    },
    linkToSchool() {
      this.$router.push({
        path: '/school'
      })
    },
    linkMoreHandler() {
      this.$router.push({
        path: '/rank'
      })
    },
    linkToMajor() {
      this.$router.push({
        path: '/major'
      })
    },
    linkNewHandler() {
      this.$router.push({
        path: '/news'
      })
    },
    changeRecommend(index) {
      this.activeBtnIndex = index;
      this.recommendList = [];
      this.recommendStatus = '1';
      this.recommendSchool();
    },
    recommendSchool() {
      recommendSchool(this.btnList[this.activeBtnIndex].type).then(res => {
        if(res.data.length == 0) {
          this.recommendStatus = '2';
        } else {
          this.recommendStatus = '3';
          this.recommendList = [...res.data];
        }
      })
    },
    getRecomendVideo() {
      getRecomendVideo().then(res => {
        if(res.data.length == 0) {
          this.videoStatus = '2';
          return
        } 
        this.videoStatus = '3';
        this.videoList = [...res.data];
      })
    },
    changeSchoolNewsHandler(e) {
      this.activeCateIndex =e.index;
      this.newsList = [];
      this.newsStatus = '1';
      this.schoolNewsHandler('1');
    },
    newsCardListHandler() {
      this.schoolNewsHandler('1');
      // newsCate().then(res => {
      //   this.newsCardList = [...res.data];
      //   this.schoolNewsHandler('1');
      // })
    },
    schoolNewsHandler(page) {
      let cate_id = '5';
      newsList(page, cate_id, 6).then(res => {
        if(res.data.count == 0) {
          this.lectureStatus = '2';
          return
        }
        this.lectureStatus = '3';
        const lectureList = res.data.data.map(item => {
            if(!item.banner_url) {
              let index = Math.random();
              index = index * 10;
              index = Math.ceil(index); 
              item.banner_url = require('../../assets/images/news'+ index + '.png');
          } else {
              item.banner_url = 'https://gaokao.zmpajx.com/' + item.banner_url;
          }
            return item;
        })
        this.lectureList = [...lectureList];
      })
      schoolNews(localStorage.getItem("area")).then(res => {
        if(res.data.length == 0) {
            this.newsStatus = '2';
            return
        }
        this.newsStatus = '3';
        // const newsList = res.data.map(item => {
        //     if(!item.banner_url) {
        //         let index = Math.random();
        //         index = index * 10;
        //         index = Math.ceil(index); 
        //         item.banner_url = require('../assets/images/news'+ index + '.png');
        //     } else {
        //         item.banner_url = 'https://gaokao.zmpajx.com/' + item.banner_url;
        //     }
        //     return item;
        // })
        this.newsList = res.data;
      })
    },
    goDetailHandler(id) {
      this.$router.push({
				path:'/newsDetail',
          query: {
              id: id
          }
			})
    },
    linkToDetail(id) {
      this.selectId = id;
      if(!this.$store.state.user.token) {
        this.$store.commit('user/LOGINSTATUS', true);
        return
      };
      getVideoUrl(this.selectId).then( res => {
          if(res.status == 400) {
            localStorage.setItem("isNewUser","false");
            this.$store.commit('user/SHOWVIP', true);
          } else {
              this.videoUrl = res.data;
              window.open(res.data, '_blank');
          }
      })
    },
    addSpeClass(index) {
      this.activeNavIndex = index;
    },
    removeSpeClass() {
      this.activeNavIndex = '';
    },
    linkEvaluationDetailHandler(id) {
      switch(id){
        case 0:
          this.$router.push({
            path: "/interest"
          });
          break;
        case 1:
          this.$router.push({
            path: "/character"
          });
          break;
        case 3:
          this.$router.push({
            path: "/goal"
          });
          break;
        case 2:
          this.$router.push({
            path: "/"
          });
        break;
        default:
          break;
      }
    },
    getEvaluationTimes() {
      getEvaluationTimes().then(res => {
        let experienceList = [];
        res.data.map(item => {
          experienceList[item.test_id-1] = item.test_use_count;
        })
        this.experienceList = [...experienceList];
      })
    },
    changeBanner(index) {
        this.bannerIndex = index;
    },
    showVipHandler() {
      if(!this.$store.state.user.token) {
        this.$store.commit('user/LOGINSTATUS', true);
      } else {
        localStorage.setItem("isNewUser","false");
        this.$store.commit('user/SHOWADDVIP', true);
      }
    },
    // toolsHandler(index) {
    //   switch(index){
    //     case 0:
    //       this.$router.push({
    //         path: "/tools-batch"
    //       });
    //       break;
    //     case 1:
    //       this.$router.push({
    //         path: "/tools-rank"
    //       });
    //       break;
    //     case 2:
    //       this.$router.push({
    //         path: "/tools-score"
    //       });
    //     break;
    //     default:
    //       break;
    //   }
    // },
    goToLinkToolsBatch() {
      this.$router.push({
        path: "/toolsBatch"
      });
    },
    goToLinkToolsRank() {
      this.$router.push({
        path: "/toolsRank"
      });
    },
    goToLinkToolsScore() {
      this.$router.push({
        path: "/toolsScore"
      });
    },
    goToLinkTools() {
      this.$router.push({
        path: "/tools"
      });
    },
    clickMoreHander(path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/css/variables.scss";
  @font-face {
    font-family: 'DINCond-Black';
    src: url('../../assets/fonts/DINCond-Black.otf');
  }
  .banner-box {
    width: 100%;
    height: 478px;
    position: relative;
  }
  .banner {
    width: 100%;
    height: 478px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
	  background-origin:border-box;
    button {
      width: 136px;
      height: 50px;
      background: rgba(255,255,255,0.20)!important;
      border: 1px solid #ffffff!important;
      border-radius: 8px;
      position: absolute;
      bottom: 90px;
      font-size: 18px;
      font-weight: 400;
      text-align: center;
      color: #ffffff!important;
      left: calc(50% - 594px);
    }
    .banner-btn0 {
      background: rgba(255,103,26,0.10)!important;
      border: 1px solid #ff671a!important;
      color: #ff671a!important;
    }
    button:hover {
      background: rgba(255,255,255,0)!important;
    }
  }
  .zytb-right {
    @include gwidth;
    @include gflex;
    position: absolute;
    top: 0;
    z-index: 999;
    left: 50%;
    transform: translateX(-50%);
  }
  .zytb-box {
    width: 384px;
    height: 430px;
    background: rgba(255,255,255,0.90);
    border-radius: 10px;
    box-shadow: 0px 4px 8px 0px rgba(157,67,0,0.18); 
    backdrop-filter: blur(7px);
    margin-top: 24px;
    padding: 24px 24px;
    position: absolute;
    box-sizing: border-box;
    right: 0%;
    .zytb-img1 {
      width: 48px;
      height: 48px;
    }
    h2 {
      font-size: 22px;
      color: #2c2e33;
      font-weight: 500;
      margin: 0;
      margin-left: 20px;

    }
    h4 {
      font-size: 14px;
      color: #909399;
      font-weight: 400;
      margin: 0;
      margin-top: 8px;
      margin-left: 14px;
    }
    .zytb-form {
      margin-top: 16px;
      position: relative;
      z-index: 990;
    }
    .select-subject {
      margin-bottom: 16px!important;
    }
  }
  .white-color-bg {
    background: #fff;
    width: 100%;
  }
  .spe-box {
    margin-bottom: 64px;
    .el-col-3 {
      width: 120px;
      height: 137px;
      background: #f5f7fa;
      border-radius: 8px;
    }
    text-align: center;
    img {
      width: 96px;
      height: 96px;
    }
    h5 {
      font-size: 18px;
      font-weight: 400;
      color: #2c2e33;
      margin: 0 0 18px 0;
    }
    .active-spc-class {
      cursor: pointer;
      background: #fff1eb;
      h5 {
        color: $common-color!important;
      }
    }
  }
  // .evaluation-card-box1 {
  //   width: 284px;
  //   height: 200px;
  //   background: url("../../assets/images/cpbg2.jpg");
  //   background-size: contain;
  // }
  // .evaluation-card-box2 {
  //   width: 284px;
  //   height: 200px;
  //   background: url("../../assets/images/cpbg1.jpg");
  //   background-size: contain;
  // }
  .school-box {
    @include gwidth;
    margin: 0 auto;
  }
  .evaluation-box {
    margin-bottom: 64px;
    .evaluation-card {
      width: 384px;
      height: 302px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 10px 2px rgba(63,59,56,0.08); 
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
    }
    .evaluation-card:hover {
        box-shadow: 0px 8px 16px 2px rgba(63,59,56,0.08); 
      h3 {
        color: $common-color;
      }
    }
    .evaluation-card div div {
      padding: 20px 24px 0 24px;
    }
    .evaluation-img1 {
      padding: 0!important;
      img {
        width: 384px;
        height: 160px;
        position: relative;
        bottom: 0px;
        right: 0px;
      }
    }
    h3 {
      font-size: 20px;
      color: #332e2c; 
      font-weight: 600;
      margin: 0;
    }
    h5 {
      font-size: 14px;
      color: #66605e;
      font-weight: 400;
      margin: 0;
      margin-top: 8px;
    }
    h6 {
      font-size: 12px;
      font-weight: 400;
      margin: 0;
      color: #999390;
      margin-top: 20px;
      img {
        width: 14px;
        height: 14px;
        position: relative;
        top: 3px;
      }
    }
  }
  .rank-box1 {
    width: 67%;
    margin-right: 3.5%;
    .school-rank-list {
      flex-direction: row;
      flex-wrap: wrap;
    }
    .school-rank-list {
      .el-col-8 {
        margin-bottom: 16px;
        cursor: pointer;
        width: 254px;
        height: 80px;
        background: #f5f7fa;
        border-radius: 8px;
        padding: 16px;
        box-sizing: border-box;
      }
      .el-col-8:hover {
        background: #fff1eb;
        h6 {
          color: $common-color;
        }
      }
    }
    .school-rank-item {
      .el-col-18 {
        padding-left: 6px;
      }
    }
    .el-col {
      text-align: left;
      .rank-img, .el-image {
        width: 48px;
        height: 48px;
        border-radius: 100%;
      }
      h6 {
        font-size: 18px;
        font-weight: 400;
        color: #2c2e33;
        margin: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
      }
      
    } 
  }
  .el-col-7 {
    padding-left: 2%;
  }
  .recom-btn {
    display: none;
  }
  .recommend-box > .el-col {
      margin: 13px 0;
      line-height: 22px;
    }
  .recommend-box {
    min-height: 445px;
    .el-col-17 {
      cursor: pointer;
    }
    .el-col-5 {
      text-align: right;
      position: relative;
      img {
        width: 12px;
        height: 16px;
        position: absolute;
        top: 1px;
      }
      span {
        margin-left: 18px;
      }
      .span-top {
        color: $common-color1;
      }
    }
    .rank-number {
      width: 18px;
      height: 18px;
      background: #f0f2f5;
      border-radius: 3px;
      font-size: 14px;
      color: #909399;
      font-weight: 600;
      text-align: center;
      line-height: 18px;
      margin-top: 2px;
    }
    .rank-number-top1,.rank-number-top2,.rank-number-top3 {
      background: none;
      img {
          width: 18px;
          height: 18px;
      }
    }
    h6 {
      font-size: 16px;
      color: #66605e;
      margin: 0;
      font-weight: 400;
    }
    h6:hover {
      color: $common-color;
    }
    .h6-top2 {
      color: $common_color1;
    }
  }
  .class-box {
    margin-top: -16px;
    margin-bottom: 6px;
    min-height: 300px;
    cursor: pointer;
    .class-box-list {
      flex-direction: row;
      flex-wrap: wrap;
    }
    .class-box-list > .el-col {
      position: relative;
      width: 284px;
      height: 160px;
      border-radius: 10px;
      box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
      margin-top: 32px;
    }
    .video-box {
      position: relative;
      border-radius: 10px;
    }
    .video-bg:hover {
      // -webkit-transform: scale(1.05);
      // -moz-transform: scale(1.05);
      // -ms-transform: scale(1.05);
      // transition:all 0.5s;
      // -webkit-transition:all 0.5s;
      // -ms-transition:all 0.5s;
      box-shadow: 0px 4px 8px 0px rgba(56,56,56,0.3);
      img {
        display: block;
      }
    }
    .video-bg {
      width: 100%;
      height: 160px;
      background-size: cover;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        width: 54px;
        height: 54px;
        display: none;
      }
    }
    p {
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      @include gnowrap;
      text-align: left;
      // padding: 0 12px 0 20px;
      margin: 12px 10px;
      border-radius: 0 0 10px 0;
    }
    .video-free {
      width: 32px;
      height: 20px;
      background: #f5f1f0;
      border: 1px solid #ccc6c4;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 400;
      color: #66605e;
      text-align: center;
      line-height: 20px;
      position: relative;
      top: 9px;
      left: 0px;
    }
    .video-free-vip {
      background: #fff5f0;
      border: 1px solid $common-color;
      border-radius: 2px;
      color: $common-color;
    }
  }
  .school-search-box {
    background: url("../../assets/images/school-search.png") no-repeat;
    background-size: 100% 100%;
    height: 362px;
    margin-top: 64px;
    text-align: center;
    padding: 80px 0;
    h2 {
      font-size: 48px;
      font-weight: 600;
      color: #ffffff;
      margin: 0;
      letter-spacing: 6px;
      line-height: 67px;
    }
    h5 {
      font-size: 18px;
      font-weight: 400;
      color: rgba(255,255,255,0.85);
      margin: 0;
      margin-top: 20px;
      line-height: 25px;
    }
    .el-button {
      width: 136px;
      height: 50px;
      background: rgba(255,255,255,0.20)!important;
      border: 1px solid #ffffff;
      border-radius: 8px;
      margin-top: 40px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
    }
    .el-button:hover {
      background: rgba(255,255,255,0)!important;
    }
  }
  .news-infor-box {
    @include gwidth;
  }
  .lecture-box {
    width: 67%;
    margin-right: 3.5%;
    .lecture-list {
      flex-direction: row;
      flex-wrap: wrap;
      .el-col-8 {
        width: 254px;
        margin-bottom: 32px;
        cursor: pointer;
      }
      // .el-col-8:nth-child(3n) {
      //   float: right;
      // }
       .el-col-8:not(:nth-child(3n)) {
        margin-right: 15px;
      }
      .lecture-img {
        width: 254px;
        height: 134px;
        border-radius: 10px;
        background: url("../../assets/images/news1.png") no-repeat;
        background-size: cover;
      }
      p {
        font-size: 16px;
        font-weight: 600;
        color: #2c2e33;
        margin: 16px 0 12px 0;
        @include gnowrap;
      }
      .lecture-time {
        font-size: 14px;
        font-weight: 400;
        color: #909399;
      }
      .el-col-8:hover {
        p {
          color: $common-color;
        }
      }
    }
  }
  .news-box1 {
    font-size: 16px;
    color: #332e2c;
    font-weight: 400;
    .news-title {
      margin-bottom: 27px;
      cursor: pointer;
      @include gnowrap;
      line-height: 22px;
    }
    .news-title:hover {
      color: $common-color;
    }
    // padding-left: 2%;
    // .news-list {
    //   cursor: default;
    //   padding: 28px 0;
    // }
    // .news-list:not(:last-child) {
    //   border-bottom: 1px solid #f5f7fa;
    // }
    // h3 {
    //   font-size: 20px;
    //   font-weight: 500;
    //   color: #2c2e33;
    //   margin: 0;
    // }
    // h3:hover {
    //   color: #3272ff;
    // }
    // .news-date {
    //   font-size: 14px;
    //   color: #909399;
    //   margin-top: 14px;
    // }
  }
	.zytb-infor {
		margin-top: 32px;
		position: relative;
		z-index: 990;
		.grid-content {
			height: 214px;
			background: rgba(255,255,255,0.80);
			border-radius: 8px;
			padding: 20px;
			font-size: 14px;
			color: #909399;
			box-sizing: border-box;
			position: relative;
			canvas {
				top: -36px;
			}
		}
		.grid-content-diff1 {
			padding: 24px 42px 0 20px;
			@include gflex;
			justify-content: space-between;
			.zytb-count {
				margin-bottom: 16px;
				font-size: 18px;
				font-weight: 600;
				margin-top: 5px;
			}
			.zytb-count-diff {
				color: #139B83;
			}
			.zytb-count-diff1 {
				color: #3272ff; 
			}
			.zytb-count-diff2 {
				color: #fe9f0a;
			}
		}
    .zytb-count-zero {
      position: relative;
      top: 4px;
    }
		.zytb-content {
			padding: 12px 20px 0 24px;
		}
		.zytb-grade {
			font-size: 56px;
			font-weight: 900;
			color: #fe9f0a;
			margin-right: 2px;
			font-family: 'DINCond-Black';
		}
		.zytb-rank {
			margin: 8px 0 61px 0;
		}
		.zytb-line {
			display: inline-block;
			margin:0 12px;
			height: 14px;
			border-left: 1px solid #c4c7cc;
			position: relative;
			top: 2px;
		}
		.zytb-subject {
			font-size: 16px;
			color: #5e6166;
			align-items: center;
		}
		.zytb-update {
			position: absolute;
			right: 20px;
			top: 24px;
			font-size: 14px;
			color: #3272ff;
			cursor: pointer;
		}
	}
	.zytb-school {
		img {
			width: 32px;
			height: 32px;
			margin-bottom: 16px;
		}
		button {
			width: 48px;
			height: 24px;
			background: #ffffff;
			border: 1px solid #3272ff;
			border-radius: 5px;
			font-size: 14px;
			color: #3272ff;
			margin-top: 21px;
			text-align: center;
		}
		.zytb-count {
			margin-top: 8px;
			span {
				font-size: 32px;
				color: #139b83;
				margin-right: 5px;
			}
		}
		.zytb-count-diff1 span {
			color: #3272ff;
		}
		.zytb-count-diff2 span {
			color: #fe9f0a;
		}
	}
  .vip-img {
    background: url("../../assets/images/banner_vip1.png") no-repeat center;
    width: 100%;
    height: 88px;
    margin-bottom: -56px;
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
	  background-origin:border-box;
    position: relative;
    background-color: #fff;
    margin-top: 152px;
    .vip-img-content {
      @include gwidth;
      @include gflex;
      line-height: 88px;
      h3 {
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        margin: 0;
        padding-left: 8px;
      }
    }
    .el-col-1 {
      position: relative;
    }
    .el-col-11 {
      position: relative;
    }
    .vip-img-icon {
      width: 44px;
      height: 44px;
      position: relative;
      top: 47%;
      transform: translateY(-50%);
    }
    .vip-img-person {
      position: absolute;
      bottom: 0;
      width: 238px;
      height: 216px;
      right: 0;
    }
    button {
      border: none;
      background: none;
      color: #ffffff;
      font-weight: 400;
      font-size: 16px;
      width: 96px;
      height: 40px;
      background: linear-gradient(133deg,#ffce5d 1%, #ffa02f 97%, #ffa02f 97%);
      border-radius: 5px;
    }
  }
  .no-data-box {
    position: relative;
    top: 150px;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
        margin-left: -14px;
    }
  }
  // .tools-box {
  //   margin-top: 30px;
  //   .tools-title {
  //     font-size: 18px;
  //     font-weight: 600;
  //     color: #2c2e33;
  //     font-weight: 600;
  //     text-align: left;
  //     margin-bottom: 20px;
  //   }
  //   .tools-img {
  //     width: 20px;
  //     height: 20px;
  //     position: relative;
  //     top: 2px;
  //   }
  //   .infor-right {
  //     text-align: right;
  //     a {
  //         text-decoration:none;
  //         color: #3272ff;
  //         font-size: 14px;
  //         cursor: pointer;
  //     }
  //     img {
  //         width: 14px;
  //         height: 14px;
  //         margin-left: 2px;
  //         position: relative;
  //         top: 2px;
  //     }
  //   }
  //   .tools-item-content {
  //     height: 140px;
  //     border-radius: 10px;
  //     background: #ffffff;
  //     border: 1px solid #ebedf0;
  //     padding: 20px 16px 20px 20px;
  //     box-sizing: border-box;
  //     box-shadow: 0px 0px 7px 0px rgba(44,46,51,0.10); 
  //     cursor: pointer;
  //     .tools-batch {
  //       width: 100px;
  //       height: 100px;
  //     }
  //     h6 {
  //       font-size: 18px;
  //       font-weight: 500;
  //       color: #2c2e33;
  //       margin: 0;
  //       margin: 6px 8px 0 16px;
  //     }
  //     .tools-arrow {
  //         width: 15px;
  //         height: 14px;
  //         position: relative;
  //         top: 9px;
  //     }
  //     .tools-desc {
  //       font-size: 14px;
  //       color: #5e6166;
  //       font-weight: 400;
  //       text-align: left;
  //       margin-left: 16px;
  //       margin-top: 14px;
  //       line-height: 22px;
  //     }
  //   }
  //   .tools-item-content:hover {
  //     background: #f5f7fa;
  //   }
  // }
</style>